import { Component, Input, OnInit } from '@angular/core';
import { Pim } from '../../../../models/pim';

@Component({
    selector: 'lib-pim-product-basic-info',
    templateUrl: './pim-product-basic-info.component.html',
    styleUrls: ['./pim-product-basic-info.component.css'],
    standalone: false
})
export class PimProductBasicInfoComponent implements OnInit {
  @Input()
  pimProduct: Pim;

  constructor() {}

  ngOnInit() {}
}
